export const config = {
    name: 'Checkbox',
};
